// Deriva a URL da MINIATURA a partir da URL da foto original, sem nenhuma leitura extra.
//
// A Cloud Function `gerarMiniaturaFoto` grava a miniatura em `checkins/{id}/thumbs/{arquivo}` COPIANDO
// o token de download da original — então a única diferença entre as duas URLs é o `thumbs%2F` no
// meio do caminho. Por isso dá para montar aqui, no cliente:
//
//   .../o/checkins%2FABC%2Ffoto.jpg?alt=media&token=X
//   .../o/checkins%2FABC%2Fthumbs%2Ffoto.jpg?alt=media&token=X   <- mesma coisa + thumbs%2F
//
// Devolve null quando a URL não tem o formato esperado (foto antiga com outro host, uri local da fila
// offline, etc.) — quem chama cai na original. O componente `FotoThumb` também cai na original se a
// miniatura simplesmente não existir ainda.
export function urlMiniatura(url?: string | null): string | null {
  if (!url || typeof url !== 'string') return null;
  const i = url.indexOf('/o/');
  if (i < 0) return null;
  const fimPath = url.indexOf('?', i);
  const inicio = i + 3;
  const caminho = fimPath < 0 ? url.slice(inicio) : url.slice(inicio, fimPath);
  const resto = fimPath < 0 ? '' : url.slice(fimPath);

  // O caminho vem percent-encoded (`%2F`), mas alguns SDKs devolvem com `/` literal — trata os dois.
  const sep = caminho.lastIndexOf('%2F') >= 0 ? '%2F' : (caminho.lastIndexOf('/') >= 0 ? '/' : null);
  if (!sep) return null;
  const corte = caminho.lastIndexOf(sep);
  const pasta = caminho.slice(0, corte);
  const arquivo = caminho.slice(corte + sep.length);
  if (!pasta || !arquivo) return null;
  if (pasta.endsWith(`thumbs`)) return url; // já é a miniatura

  return `${url.slice(0, inicio)}${pasta}${sep}thumbs${sep}${arquivo}${resto}`;
}
